<template>
  <div :class="[classObj,themeName]" @mousedown="closeContextMenu">
    <navbar class="main-common" />
    <sidebar class="sidebar-container main-common" />
    <template>
      <div v-if="showTab && showTabs" class="big-main-container">
        <div class="tabs-wrt">
          <div class="content-tabs main-common" :class="{'content-tabs-hide' : activeIndex == -1}">
            <el-tabs
              v-if="showCommonView"
              ref="topTabs"
              v-model="editableTabsValue"
              class="main-tabs"
              @tab-click="tabClick"
              @tab-remove="removeTab"
            >
              <el-tab-pane
                v-for="(item) in editableTabs"
                :key="item.path"
                :label="$t(item.title)+ ` ${item.showId ? item.showId : ''}`"
                :name="item.path"
                :closable="item.name !== 'home'"
              />
            </el-tabs>
            <div v-if="responseNetTime" class="net-monitor-wrap" :class="{'net-monitor-wran': responseNetTime>5000}">
              <span class="icon" />
              <div id="net_monitor_div2">{{ responseNetTime }}ms</div>
            </div>
          </div>
          <div class="content-wrapper">
            <div slot="content">
              <app-main />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="big-main-container">
        <app-main />
      </div>
    </template>
    <!-- <div class="footer-container">JDL 京东物流 </div> -->
    <!-- tab右键菜单 在内容中内个头上的tab可以右键点击-->
    <!-- <ContextMenu :context-menu-info="contextMenuInfo" /> -->
  </div>
</template>

<script>
import { SappModule } from '@/store/modules/app'
import { Navbar, Sidebar, AppMain, ContextMenu } from '@/components/common'
import json from '@/i18n/pathToCode.json'
import { NetMonitor } from '@/assets/js/net-monitor'
import microApp, { getActiveApps } from '@micro-zoe/micro-app'

let lastMatched = [] // 上次路由匹配的路径

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
    // ContextMenu
  },
  provide: {
    // 模板工程特性配置开关，可以通过此配置开关相应的特性
    features: {
      // 是否开启常用菜单
      favouritesNav: true
    }
  },
  data() {
    return {
      showTabs: true,
      responseNetTime: '',
      contextMenuInfo: {
        bShow: false, // 是否展示右键菜单
        event: null
      }
    }
  },
  computed: {
    activeIndex() {
      this.activeName = '' + SappModule.topMenuActiveIndex// > -1 ? '' + SappModule.topMenuActiveIndex : '';
      return SappModule.topMenuActiveIndex
    },
    sidebar() {
      return !SappModule.sidebar
    },
    showCommonView() {
      return SappModule.showCommonView
    },
    themeName() {
      return `theme-${SappModule.themeColor}`
    },
    showTab() {
      return SappModule.showTab
    },
    classObj() {
      return {
        hideSidebarAll: !SappModule.sidebar.showSidebar,
        hideSidebar: !SappModule.sidebar.opened,
        showSidebar: SappModule.sidebar.opened,
        hideNavbar: !SappModule.showCommonView,
        hideTabs: !SappModule.showTab
      }
    },
    editableTabs() {
      const editableTabs = SappModule.editableTabs

      editableTabs.forEach(node => {
        console.log('顶部tabs', node)
        if (node.params) {
          console.log('顶部tabs222', node.params.pathMatch, '/' + node.params.pathMatch, json['/' + node.params.pathMatch], json)
          if (json['/' + node.params.pathMatch]) {
            node.title = json['/' + node.params.pathMatch]
          } else if (json[node.path]) {
            node.title = json[node.path]
          } else {
            if(node && node.params && node.params.pathMatch && (node.params.pathMatch.indexOf('supplement/emailTemplateVersionManagement') > -1 || node.params.pathMatch.indexOf('supplement/smsTemplateVersionManagement') > -1)) {
              node.title = json['/' + this.removeLastSegment(this.removeLastSegment(node.params.pathMatch))]
            } else if(node && node.params && node.params.pathMatch){
              node.title = json['/' + this.removeLastSegment(node.params.pathMatch)]
            }
          }
          if (!node.title && node.path) {
            console.log(this.removeLastSegment(node.path))
            node.title = json[this.removeLastSegment(node.path)]
          }
          console.log('顶部tabs333', node)
        }
      })
      return editableTabs
    },
    editableTabsValue: {
      get() {
        return SappModule.editableTabsValue
      },
      set() {
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue.name === 'noPermission') {
          this.showTabs = false
          return
        } else {
          this.showTabs = true
        }
        if (newValue.meta.topIndex !== undefined) {
          // 判断是否切换左侧导航栏
          SappModule.setCurrentActiveMenuIndex(newValue.meta.topIndex)
          // 切换顶部菜单选中态
          SappModule.setTopMenuActiveIndex(newValue.meta.topIndex)
        }
        // 当需要展示框架时：首页与帮助中心隐藏左边菜单其他展示
        if (SappModule.showCommonView !== false) {
          // newValue.path === '/' ||
          newValue.path === '/' || newValue.path === '/helpCenter' ? SappModule.hideSideBar() : SappModule.showSideBar()
        }
        // 支持首次加载首页
        const matchedArr = newValue.matched.map(item => item.path).filter(item => item !== '/' && item !== '')
        if (this.editableTabsValue !== newValue.path && newValue.name !== 'home') {
          // 支持首次加载首页  // 添加页面
          SappModule.addTab({
            ...newValue
          })
        }
        // 更新上一次路径
        lastMatched = matchedArr
      }
    }
  },
  mounted() {
    if (this.$refs && this.$refs.topTabs) {
      // 为tab项添加右键菜单功能
      this.$refs.topTabs.$el.addEventListener('contextmenu', (e) => {
        if (/^tab-[\w|/|-]+$/.test(e.target.id)) {
          this.contextmenuHandler(e)
        }
      }, false)
    }
    // 网络监控
    // 参数url 为该项目所属域名，因为访问其他域名会有跨域问题，需要在nginx上做反向代理实现访问
    // 参数time，为定时访问频率，默认10s， 尽量在[5, 20]区间
    const monitor = new NetMonitor('', 10000)
    monitor.timing()
    window.addEventListener('responseNetTime', this.handleResponseNetTimeChange)
  },
  methods: {
    removeLastSegment(str) {
      // 找到最后一个斜杠的位置
      const lastSlashIndex = str ? str.lastIndexOf('/') : -1

      // 如果找到了斜杠，则返回从开始到最后一个斜杠之前的部分
      // 否则返回原字符串
      return lastSlashIndex !== -1 ? str.substring(0, lastSlashIndex) : str
    },
    handleResponseNetTimeChange(data) {
      this.responseNetTime = window.responseNetTime
    },
    tabClick(e) {
      // 读取store中路由参数
      const item = SappModule.editableTabs[e.index]
      this.$router.push({ name: item.name, params: item.params, query: item.query }).catch(err => err)
    },

    removeTab(e) {
      console.log('主应用关闭页签', e)
      microApp.forceSetGlobalData({ path: e }, () => {
        console.log('主应用tab关闭数据已经发送完成', { path: e }, this.$route)
      })
      SappModule.removeTab(e)
      const current = SappModule.currentTab
      this.$router.replace({ name: current.name, params: current.params, query: current.query }).catch(err => err)
    },

    contextmenuHandler(e) {
      e.preventDefault()
      this.contextMenuInfo.bShow = true
      this.contextMenuInfo.event = e
    },
    // 鼠标按下时，关闭tab右键菜单
    closeContextMenu(e) {
      if (!e.target.getAttribute('contextmenu-item') && this.contextMenuInfo.bShow) {
        this.contextMenuInfo.bShow = false
      }
    }
  }
}
</script>
<style lang="scss">
.content-tabs{
  height: 48px;
  background-color: #fff;
  &.content-tabs-hide{
    margin-left: 16px !important;
  }
  .main-tabs{
    width: calc(100% - 130px);
    display: inline-block;
  }
  .net-monitor-wrap{
    float: right;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100px;
    padding: 5px 9px;
    height: 24px;
    background: rgba(245,245,246,1);
    border-radius: 20px;
    margin-right: 20px;
    margin-top: 12px;
    .icon{
      width: 16px;
      height: 16px;
      background-image: url('~@/assets/img/network.png');
      margin-right: 7px;
      background-repeat: no-repeat;
      background-size: 16px
    }
    #net_monitor_div2{
      color: rgba(82,87,101,1);
    }
  }
  .net-monitor-wran{
    background: rgba(252,55,55,0.1);
    .icon{
      width: 16px;
      height: 16px;
      margin-right: 7px;
      background-repeat: no-repeat;
      background-size: 16px
    }
    #net_monitor_div2{
      color: rgba(252,55,55,1);
    }
  }
  .el-tabs__nav-prev{
    top: 4px;
  }
  .el-tabs__nav-next{
    top: 4px;
  }
  .el-tabs--top, .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll{
    height: 48px;
  }
  .el-tabs__nav{
    height: 44px;
    margin-top: 4px;
  }
  .el-tabs__nav-wrap{
    box-shadow: none !important;
  }
  .el-tabs__active-bar{
    display: none;
  }
  .el-tabs__item{
    background-color: #fff;
  }
  .el-tabs__item{
    height: 44px;
    text-align: center;
    line-height: 44px;
    font-size: 14px;
    color: #868D9F !important;
    padding: 0 16px !important;
    box-sizing: border-box;
    vertical-align: top;
    border-radius: 12px 12px 0 0;
    &::after{
      top: 14px !important;
      width: 1px !important;
      height: 16px !important;
      border: none !important;
      background-color: #f1f2f4;
    }
    &.is-active{
      box-shadow: 12px 12px 0 0 #f3f5f9, -12px 12px 0 0 #f3f5f9;
      background-color: rgba(245,245,246,1);
      text-align: center;
      line-height: 44px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(60,110,240,1);
      vertical-align: top;
      position: relative;
      z-index: 1;
      &::before{
        width: 16px;
        height: 44px;
        vertical-align: top;
        background-color: #fff;
        border-radius: 0 0 12px 0;
        display: inline-block;
        content: '';
        position: absolute;
        left: -16px;
      }
      &::after{
        width: 16px !important;
        height: 44px !important;
        vertical-align: top !important;
        background-color: #fff !important;
        border-radius: 0 0 0 12px !important;
        display: inline-block !important;
        content: '' !important;
        position: absolute !important;
        right: -16px !important;
        top: 0 !important;
      }
    }
  }
}
.el-tabs__item{
  vertical-align: top;
}
.el-tabs__item .el-icon-close{
  visibility: visible !important;
}
</style>
<style lang="scss" scoped>
  @import "~@/assets/styles/mixins.scss";

  .app-wrapper {
    &:after {
      content: "";
      display: table;
      clear: both;
    }
    position: relative;
    height: 100%;
    width: 100%;
  }
  .tabs-wrt{
    .content-wrapper {
      background: #ffffff;
    }
  }

  .content-tabs,
  .jdwl-admin-red .content-tabs{
    /deep/ .el-tabs{
      &__header{
        margin: 0 0 0px -20px;
      }
      &__nav-wrap{
        padding:0 20px;
        background: #fff;
        box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.08);
        &.is-scrollable{
          padding:0 40px;
        }
        &::after{
          display:none;
        }
      }
      &__item{
        color:#666;
        padding: 0 10px;
        &.is-active{
          @include font_color("main-color");
        }
        .el-icon-close{
          visibility: hidden;
        }
        &:hover,
        &.is-active{
         .el-icon-close{
            visibility: visible;
          }
        }
        &.is-top:not(:last-child):after {
          position: absolute;
          right: 1px;
          top: 10px;
          content: "";
          height: 20px;
          border-left: 1px solid rgba(217, 217, 217, 1);
        }
      }
      &__nav-prev {
          left: 20px;
      }
      &__nav-next {
        right: 20px;
      }
    }
  }
</style>
